import { useNavigate } from 'react-router-dom';
import { PublicLayout } from '../components/layout/PublicLayout';
import { Button } from '../components/ui/button';
import { AlertCircle } from 'lucide-react';

const PaymentCancelledPage = () => {
  const navigate = useNavigate();

  return (
    <PublicLayout>
      <div className="max-w-lg mx-auto px-4 py-16 text-center">
        <AlertCircle className="h-16 w-16 text-amber-400 mx-auto mb-4" />
        <h1 className="font-heading text-2xl font-bold mb-2">Payment Cancelled</h1>
        <p className="text-slate-500 mb-6">
          Your payment was not completed. No charge has been made.
        </p>
        <div className="flex gap-3 justify-center flex-wrap">
          <Button variant="outline" onClick={() => navigate('/')}>
            Back to Home
          </Button>
          <Button className="btn-panashe" onClick={() => navigate('/search')}>
            Search Trips Again
          </Button>
        </div>
      </div>
    </PublicLayout>
  );
};

export default PaymentCancelledPage;
